import './Textarea.scss';
import classNames from 'classnames';
import * as React from 'react';

export type ElementSize = 'small' | 'default' | 'large';
export type Variant = 'default' | 'inset';

export interface ITextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  variant?: Variant;
  elementSize?: ElementSize;
  showErrorBorder?: boolean;
}

const Textarea = ({
  className,
  elementSize,
  variant,
  showErrorBorder,
  ...props
}: ITextareaProps) => (
  <textarea
    className={classNames(
      'textarea',
      className,
      elementSize ? `is-${elementSize}` : 'is-small',
      variant ? `is-${variant}` : null,
      showErrorBorder && 'has-error-border',
    )}
    {...props}
  />
);

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/FormElements/Textarea.tsx